import { ANONYMOUS_EDITING_KEYS_ADD } from 'constants/action_names';

export const addKey = (matrixId, key) => ({
  type: ANONYMOUS_EDITING_KEYS_ADD,
  matrixId,
  key,
});
